module.exports = __webpack_public_path__ + "img/ArmadilloTextLogo_Mobile.419943ea.svg";